<template>
  <div class="page">
    <box fill>
      <el-form label-position="" label-width="80px" class="EL-Form EL-foemFlex">
        <el-row style="width: 100%">
          <el-col :lg="5" :xl="5">
            <el-form-item label="开始日期" class="EL-Form-Item">
              <el-date-picker
                v-model="pagination.requireDate[0]"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="开始日期"
                :picker-options="pickerOptions0"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="结束日期" class="EL-Form-Item">
              <el-date-picker
                v-model="pagination.requireDate[1]"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :lg="5" :xl="5">
            <el-form-item class="btn-edit-delete EL-Form-Item">
              <!-- <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                      查询
                  </el-button> -->
              <el-button class="btn-t-edit" @click="getAuxiMaterialData(1)">
                当日查询
              </el-button>
              <el-button class="btn-t-edit" @click="getAuxiMaterialData(2)">
                本周查询
              </el-button>
              <el-button class="btn-t-edit" @click="getAuxiMaterialData(3)">
                本月查询
              </el-button>
              <el-button class="btn-t-edit" @click="downLoad(1)">
                导出拣配
              </el-button>
              <el-button class="btn-t-edit" @click="downLoadDetails(1)">
                导出拣配明细
              </el-button>
              <el-button class="btn-t-edit" @click="downLoad(2)">
                导出配送
              </el-button>
              <el-button class="btn-t-edit" @click="downLoadDetails(2)">
                导出配送明细
              </el-button>
              <el-button class="btn-t-edit" @click="getAuxiMaterialData(4)">
                当年查询
              </el-button>
              <el-button class="btn-t-delete" @click="resetData()">
                重置
              </el-button>
              <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                查询
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        label-position="right"
        label-width="80px"
        class="EL-Form EL-foemFlex"
      >
        <el-row style="width: 100%">
          <el-col :lg="24" :xl="24">
            <div class="echarts-box" ref="echarts"></div>
          </el-col>
        </el-row>
        <el-row style="width: 100%">
          <el-col :lg="24" :xl="24">
            <div class="echarts-box" ref="echarts2"></div>
          </el-col>
        </el-row>
      </el-form>

      <el-divider></el-divider>
      <el-form
        label-position="right"
        label-width="80px"
        class="EL-Form EL-foemFlex"
      >
        <el-row style="width: 100%">
          <el-col :lg="24" :xl="24">
            <div class="echarts-box-zhu" ref="echarts3"></div>
          </el-col>
        </el-row>
        <el-row style="width: 100%">
          <el-col :lg="24" :xl="24">
            <div class="echarts-box-zhu" ref="echarts4"></div>
          </el-col>
        </el-row>
      </el-form>
      <!--
            <plabel text="库龄分析报表">
                <el-button v-authority="'BACK_MENU7_M8_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>-->
      <!-- 展示
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <el-table-column prop="whCode" label="仓库" />
                <el-table-column prop="lcCode" label="库位编号" />
                <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="matName" label="物料描述" />
                <el-table-column prop="batchNo" label="批号" />
                <el-table-column prop="boxBarcode" label="包装编号" />
                <el-table-column prop="checkFlag" label="是否质检">
                    <template slot-scope="scope">
                        <div v-if="scope.row.checkFlag == false">否</div>
                        <div v-if="scope.row.checkFlag == true">是</div>
                    </template>
                </el-table-column>
                <el-table-column prop="matCreateTime" label="入库日期" />
                <el-table-column prop="inventoryAge" label="库龄">
                    <template slot-scope="scope">
                        <div v-if="scope.row.inventoryAge > 0 && scope.row.inventoryAge <= 90">三个月内</div>
                        <div v-if="scope.row.inventoryAge > 90 && scope.row.inventoryAge <= 180">半年内</div>
                        <div v-if="scope.row.inventoryAge > 180 && scope.row.inventoryAge <= 365">一年内</div>
                        <div v-if="scope.row.inventoryAge > 365 && scope.row.inventoryAge <= 1095">三年内</div>
                        <div v-if="scope.row.inventoryAge > 1095">三年以上</div>
                    </template>
                </el-table-column>
            </h-table>-->
    </box>
  </div>
</template>

<script>
import * as echarts from "echarts"; // 导图全局 echarts
import moment from "moment";
export default {
  name: "InventoryAge",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //主数据
      mainData: [],
      pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        matCode: "",
        lcCode: "",
        batchNo: "",
        matName: "",
        fcCode: localStorage.getItem("fcCode") || "",
        requireDate: [],
        type: ""
      },
      pickList: [],
      distriList: [],
      taskTab: "0",

      downloadLoading: false, //下载中

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null
    };
  },
  watch: {
    pagination: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getAuxiMaterialData(newVal);
        }, 1000);
      },
      deep: true
    }
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.pagination.requireDate[0]) {
            return time.getTime() < new Date(_this.pagination.requireDate[0]);
          }
        }
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.pagination.requireDate[1]) {
            return time.getTime() > new Date(_this.pagination.requireDate[1]);
          }
        }
      };
    }
  },
  methods: {
    setPieChart(data) {
      this.$nextTick(() => {
        var myChart = echarts.init(this.$refs.echarts);

        var optionChart = {
          // title: {
          //   text: "",
          //   left: "left",
          // },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: "vertical",
            left: "right",
            type: "scroll",
            right: 10,
            top: 20,
            bottom: 20
          },
          series: [
            {
              name: "拣配",
              type: "pie",
              radius: "55%",
              center: ["40%", "50%"],
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        };

        myChart.setOption(optionChart);
      });
    },
    setDistribution(data) {
      this.$nextTick(() => {
        var myChart2 = echarts.init(this.$refs.echarts2);
        var optionChart = {
          // title: {
          //   text: "",
          //   left: "left",
          // },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: "vertical",
            left: "right",
            type: "scroll",
            right: 10,
            top: 20,
            bottom: 20
          },
          series: [
            {
              name: "配送",
              type: "pie",
              radius: "55%",
              center: ["40%", "50%"],
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        };

        myChart2.setOption(optionChart);
      });
    },
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getAuxiMaterialData();
      }, 1000);
    },
    //获取数据
    getAuxiMaterialData(buttonType) {
      var start = "";
      var end = "";
      if (buttonType == "1") {
        start = moment().format("YYYY-MM-DD");
        end = moment()
          .add("d", 1)
          .format("YYYY-MM-DD");
      } else if (buttonType == "2") {
        //周

        start = moment()
          .startOf("week")
          .add("d", 1)
          .format("YYYY-MM-DD");
        end = moment()
          .add("d", 1)
          .format("YYYY-MM-DD");
      } else if (buttonType == "3") {
        start = moment()
          .startOf("month")
          .format("YYYY-MM-DD"); //当前月开始时间
        end = moment()
          .add("d", 1)
          .format("YYYY-MM-DD");
      } else if (buttonType == "4") {
        start = moment()
          .startOf("year")
          .format("YYYY-MM-DD"); //所在年开始时间
        end = moment()
          .add("d", 1)
          .format("YYYY-MM-DD");
      } else {
        end = this.pagination.requireDate[1];
        start = this.pagination.requireDate[0];
      }
      this.getPickData(end, start);
      this.getDistributionData(end, start);
      this.getAchievementsChartPick(end, start, "pick");
      this.getAchievementsChartPick(end, start, "distri");
    },
    setPieChartZhu(dimensions, source, series, pickType) {
      this.$nextTick(() => {
        var optionChart = {
          legend: {},
          tooltip: {},
          dataset: {
            dimensions: dimensions,
            source: source
          },
          xAxis: { type: "category" },
          yAxis: {},
          series: series
        };
        if (pickType == "pick") {
          var myChart3 = echarts.init(this.$refs.echarts3);
          myChart3.clear();
          myChart3.setOption(optionChart);
        } else if (pickType == "distri") {
          var myChart4 = echarts.init(this.$refs.echarts4);
          myChart4.clear();
          myChart4.setOption(optionChart);
        }
      });
    },
    getPickData(end, start) {
      this.$http
        .request({
          url: "/api/stockPickDetail/getPickData",
          method: "GET",
          params: {
            fcCode: this.pagination.fcCode,
            beginTime: start || null,
            endTime: end || null
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            this.setPieChart(resp.data);
          }
        })
        .catch(error => {});
    },
    getDistributionData(end, start) {
      this.$http
        .request({
          url: "/api/stockPickDetail/getDistributionData",
          method: "GET",
          params: {
            fcCode: this.pagination.fcCode,
            beginTime: start || null,
            endTime: end || null
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            this.setDistribution(resp.data);
          }
        })
        .catch(error => {});
    },
    getAchievementsChartPick(end, start, pickType) {
      this.$http
        .request({
          url: "/api/stockPickDetail/getAchievementsChartPick",
          method: "GET",
          params: {
            fcCode: this.pagination.fcCode,
            beginTime: start || null,
            endTime: end || null,
            pickType: pickType
          }
        })
        .then(resp => {
          if (resp.status == 100) {
            let listMap = resp.data;
            if (pickType == "pick") {
              this.pickList = listMap.pick;
            }
            if (pickType == "distri") {
              this.distriList = listMap.distri;
            }

            this.setPieChartZhu(
              listMap.dimensions,
              listMap.source,
              listMap.series,
              pickType
            );
          }
        })
        .catch(error => {});
    },
    downLoad(type) {
      import("@/libs/Export2Excel").then(excel => {
        var list = type == "1" ? this.pickList : this.distriList;
        const tHeader = ["用户名称", "数量"];
        const filterVal = ["name", "value"];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: type == "1" ? "拣配" : "配送"
        });
        this.logContent = "导出";
        this.logRemarks = "product_pull：导出用户记录";
      });
    },
    async downLoadDetails(type) {
      try {
        const tHeader = [
          "拣货单号",
          "物料编号",
          "物料描述",
          "箱内数量",
          "实际拣货数量",
          "拣货扫描",
          "状态",
          "推荐库位",
          "实际库位",
          "规值",
          "箱号",
          "创建时间",
          "发起人",
          "操作人"
        ];
        const filterVal = [
          "spCode",
          "matCode",
          "matName",
          "boxQuan",
          "matQuan",
          "scanFlag",
          "distrType",
          "laCodeAdvise",
          "laCodeReal",
          "matSpecs",
          "boxBarcode",
          "createTime",
          "person",
          "name"
        ];
        const url =
          type === 1
            ? "/api/stockPickDetail/getPickDataList"
            : "/api/stockPickDetail/getDistributionDataList";
        const res = await this.$http.request({
          url: url,
          method: "GET",
          showLoading: true,
          params: {
            fcCode: this.pagination.fcCode,
            beginTime: this.pagination.requireDate[0],
            endTime: this.pagination.requireDate[1]
          }
        });
        const { status, data, message } = res;
        if (status === 100 && data) {
          const list = data || [];
          list.forEach(i => {
            i.scanFlag = i.scanFlag ? "已扫描" : "未扫描";
            if (i.distrType === "10") {
              i.distrType = "待配送";
            } else if (i.distrType === "20") {
              i.distrType = "配送中";
            } else if (i.distrType === "30") {
              i.distrType = "配送完成";
            } else if (i.distrType === "40") {
              i.distrType = "关闭";
            }
          });
          import("@/libs/Export2Excel").then(excel => {
            const data = this.formatJson(filterVal, list);
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: type === 1 ? "拣配明细" : "配送明细"
            });
            this.logContent = "导出";
            this.logRemarks = "product_pull：导出用户记录";
          });
        } else {
          this.$message.error(message);
        }
      } catch (e) {
        console.log(e);
      }
    },
    //重置
    resetData() {
      this.pagination = {
        pageNum: 1,
        pageSize: 50,
        total: 0,
        matCode: "",
        lcCode: "",
        batchNo: "",
        matName: "",
        fcCode: localStorage.getItem("fcCode") || "",
        requireDate: []
      };
      this.getAuxiMaterialData();
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  },
  mounted() {},
  activated() {
    this.pagination.requireDate = [];
    this.pagination.requireDate.push(
      moment()
        .subtract("d", 1)
        .format("YYYY-MM-DD")
    );
    this.pagination.requireDate.push(
      moment()
        .add("d", 1)
        .format("YYYY-MM-DD")
    );
    /* 获取首页的数据 */
    this.getAuxiMaterialData();
    //this.getAchievementsChartPick(moment().add('d', 1).format("YYYY-MM-DD"),moment().subtract('M', 4).format("YYYY-MM-DD"),"pick");
    //this.getAchievementsChartPick(moment().add('d', 1).format("YYYY-MM-DD"),moment().subtract('M', 4).format("YYYY-MM-DD"),"distri");
  }
};
</script>

<style scoped>
.EL-foemFlex {
  display: flex;
}

.echarts-box {
  min-height: 200px;
}
.echarts-box-zhu {
  min-height: 400px;
}
</style>
